import * as React from 'react';

enum SVGEnum {
    TYPE_CAR = 'TYPE_CAR',
    TYPE_POI = 'TYPE_POI',
    TYPE_AOI = 'TYPE_AOI',
    PLUS = 'PLUS',
    MINUS = 'MINUS',
    PLAY = 'PLAY',
    STOP = 'STOP',
    FAST = 'NEXT',
    SLOW = 'PREVIOUS'
}

class SVG extends React.PureComponent<{ type: SVGEnum }> {
    public render() {
        const props = this.props;
        switch (props.type) {
            case SVGEnum.TYPE_CAR:
                return (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.876 8.624" className="svg svg__type--car">
                        <g transform="translate(-1454.75 -490.412)">
                            <path
                                d="M14.576,118.813l-1.235-.564-1.09-1.739a1.717,1.717,0,0,0-1.465-.807H6.141a1.733,1.733,0,0,0-1.377.677l-1.408,1.843-2.347.643A1.376,1.376,0,0,0,0,120.193v.9a1.376,1.376,0,0,0,1.364,1.386h.2a1.75,1.75,0,0,0,3.387,0h5.293a1.75,1.75,0,0,0,3.387,0h.378a1.376,1.376,0,0,0,1.364-1.386v-1.024A1.373,1.373,0,0,0,14.576,118.813ZM3.258,123.152a1.119,1.119,0,1,1,1.119-1.119A1.119,1.119,0,0,1,3.258,123.152Zm8.68,0a1.119,1.119,0,1,1,1.119-1.119A1.119,1.119,0,0,1,11.938,123.152Zm2.073-1.3h-.334a1.75,1.75,0,0,0-3.478,0H5a1.75,1.75,0,0,0-3.478,0H1.361a.744.744,0,0,1-.734-.756v-.9a.742.742,0,0,1,.545-.722l2.454-.671a.307.307,0,0,0,.167-.113l1.468-1.925a1.114,1.114,0,0,1,.879-.429h4.644a1.085,1.085,0,0,1,.933.51l1.141,1.821a.311.311,0,0,0,.135.12l1.317.6a.742.742,0,0,1,.432.681v1.024h0A.744.744,0,0,1,14.012,121.847Z"
                                transform="translate(1455 374.959)"
                            />
                        </g>
                    </svg>
                );
            case SVGEnum.TYPE_POI:
                return (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.867 10.861" className="svg svg__type--poi">
                        <g transform="translate(-1494.334 -676.871)">
                            <g transform="translate(1494.333 676.871)">
                                <g transform="translate(0 0)">
                                    <g transform="translate(0)">
                                        <path
                                            d="M74.506,0a3.938,3.938,0,0,0-3.933,3.933c0,2.692,3.52,6.643,3.67,6.81a.354.354,0,0,0,.527,0c.15-.167,3.67-4.118,3.67-6.81A3.938,3.938,0,0,0,74.506,0Z"
                                            transform="translate(-70.573)"
                                        />
                                    </g>
                                </g>
                            </g>
                            <circle className="svg svg__type--poi" cx="1.474" cy="1.474" r="1.474" transform="translate(1496.829 679.521)" />
                        </g>
                    </svg>
                );
            case SVGEnum.TYPE_AOI:
                return (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.2 11.2" className="svg svg__type--aoi">
                        <g transform="translate(-1492.4 -638.4)">
                            <circle className="a" cx="1.244" cy="1.244" r="1.244" transform="translate(1496.755 638.4)" />
                            <circle className="a" cx="1.244" cy="1.244" r="1.244" transform="translate(1496.755 647.111)" />
                            <circle className="a" cx="1.244" cy="1.244" r="1.244" transform="translate(1501.111 642.755)" />
                            <circle className="a" cx="1.244" cy="1.244" r="1.244" transform="translate(1492.4 642.755)" />
                            <g className="b" transform="translate(1493.022 639.022)">
                                <path className="c" d="M4.978,0A4.978,4.978,0,1,1,0,4.978,4.978,4.978,0,0,1,4.978,0Z" />
                                <path
                                    className="d"
                                    d="M 4.977864742279053 1.000004768371582 C 2.784464836120605 1.000004768371582 1.000004768371582 2.784464836120605 1.000004768371582 4.977864742279053 C 1.000004768371582 7.1712646484375 2.784464836120605 8.955724716186523 4.977864742279053 8.955724716186523 C 7.1712646484375 8.955724716186523 8.955724716186523 7.1712646484375 8.955724716186523 4.977864742279053 C 8.955724716186523 2.784464836120605 7.1712646484375 1.000004768371582 4.977864742279053 1.000004768371582 M 4.977864742279053 4.76837158203125e-06 C 7.727065086364746 4.76837158203125e-06 9.955724716186523 2.228664875030518 9.955724716186523 4.977864742279053 C 9.955724716186523 7.727065086364746 7.727065086364746 9.955724716186523 4.977864742279053 9.955724716186523 C 2.228664875030518 9.955724716186523 4.76837158203125e-06 7.727065086364746 4.76837158203125e-06 4.977864742279053 C 4.76837158203125e-06 2.228664875030518 2.228664875030518 4.76837158203125e-06 4.977864742279053 4.76837158203125e-06 Z"
                                />
                            </g>
                        </g>
                    </svg>
                );
            case SVGEnum.PLUS:
                return (
                    <svg xmlns="http://www.w3.org/2000/svg" className="svg svg__plus" viewBox="0 0 11.6 11.6">
                        <path
                            className="a"
                            d="M10.6,4.8H6.8V1a.945.945,0,0,0-1-1,.945.945,0,0,0-1,1V4.8H1a.945.945,0,0,0-1,1,.945.945,0,0,0,1,1H4.8v3.8a.945.945,0,0,0,1,1,.945.945,0,0,0,1-1V6.8h3.8a.945.945,0,0,0,1-1A1,1,0,0,0,10.6,4.8Z"
                        />
                    </svg>
                );
            case SVGEnum.MINUS:
                return (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.6 2" className="svg svg__minus">
                        <path className="a" d="M10.6,0H1A.945.945,0,0,0,0,1,.945.945,0,0,0,1,2h9.6a.945.945,0,0,0,1-1A1,1,0,0,0,10.6,0Z" />
                    </svg>
                );
            case SVGEnum.PLAY:
                return (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="svg svg__play"><path d="M3 22v-20l18 10-18 10z"/></svg>
                );
            case SVGEnum.STOP:
                return (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"  className="svg svg__stop"><path d="M10 24h-6v-24h6v24zm10-24h-6v24h6v-24z"/></svg>
                );
            case SVGEnum.SLOW:
                return (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="svg svg__fast"><path d="M13 12l11-7v14l-11-7zm-11 0l11-7v14l-11-7zm-2 6h2v-12h-2v12z"/></svg>
                );
            case SVGEnum.FAST:
                return (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="svg svg__slow"><path d="M0 19v-14l11 7-11 7zm11 0v-14l11 7-11 7zm13-13h-2v12h2v-12z"/></svg>
                );
            default:
                return null;
        }
    }
}

export { SVG, SVGEnum };



// WEBPACK FOOTER //
// ./src/HelperFunctions/SVG.tsx